import { SvgSsoGoogleLogo, SvgSsoMicrosoftLogo } from '@/assets/images/sso';
import { useCallback, useMemo } from 'react';
import { type SSOLoginClient, navigateToSSOLoginUrl } from './sso.util';

import './sso-login-button.css';

export type SSOButtonProps = {
  email?: string;
  provider: SSOLoginClient;
  buttonProps?: React.ButtonHTMLAttributes<HTMLButtonElement>;
};

export const SSOLoginButton = ({ provider, ...props }: SSOButtonProps) => {
  const handleLogin = useCallback(async () => {
    if (!provider?.authorizationUrl) {
      return;
    }

    await navigateToSSOLoginUrl(provider, props?.email);
  }, [provider?.authorizationUrl, props?.email]);

  const { Icon, label } = useMemo(() => {
    switch (provider?.provider) {
      case 'AZURE_SINGLE_TENANT':
      case 'AZURE_MULTI_TENANT':
        return {
          Icon: SvgSsoMicrosoftLogo,
          label: 'Continue with Microsoft',
        };
      case 'GOOGLE_MULTI_TENANT':
        return {
          Icon: SvgSsoGoogleLogo,
          label: 'Continue with Google',
        };
      default:
        return {
          Icon: SvgSsoGoogleLogo,
          label: 'Continue with Google',
        };
    }
  }, [provider?.provider, provider?.authorizationUrl]);

  return (
    <button
      className="gsi-material-button"
      type="button"
      onClick={handleLogin}
      style={{ width: '100%' }}
      {...props?.buttonProps}
    >
      <div className="gsi-material-button-state" />
      <div className="gsi-material-button-content-wrapper">
        <div className="gsi-material-button-icon">
          <Icon aria-label={label} style={{ display: 'inline' }} />
        </div>
        <span className="gsi-material-button-contents">{label}</span>
        <span style={{ display: 'none' }}>{label}</span>
      </div>
    </button>
  );
};
